import React from "react";
import { RevealText } from "./RevealText";

const avatars = [
  { name: "Aria K.", role: "CTO, Fleurish", src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80" },
  { name: "Marco D.", role: "Founder, QuantMind", src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80" },
  { name: "Sasha L.", role: "PM, Kuro Labs", src: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80" },
  { name: "Jen W.", role: "CEO, NorthOps", src: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=200&q=80" },
  { name: "Kai R.", role: "Lead Eng, Drift", src: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=200&q=80" },
  { name: "Nia P.", role: "COO, Bloomly", src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80" },
  { name: "Diego S.", role: "Founder, Tilde", src: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?auto=format&fit=crop&w=200&q=80" },
  { name: "Mira A.", role: "VP, Sequence", src: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=200&q=80" },
];

const quotes = [
  {
    text: "FlowBase rebuilt our automation stack in 3 weeks. Our ops team got 18 hours back every single week.",
    author: "Marco D.",
    role: "Founder, QuantMind",
  },
  {
    text: "From the first wireframe to the final deploy, the team felt like an in-house extension. Truly rare.",
    author: "Aria K.",
    role: "CTO, Fleurish",
  },
];

export const Testimonials = () => {
  // duplicate the avatar list for seamless marquee loop
  const loop = [...avatars, ...avatars];
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-[#B026FF] mb-4">
            Trusted by Innovators
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-white">
            <RevealText>Founders, operators, and engineers</RevealText>
            <br />
            <RevealText delay={220} className="text-white/60">
              — who shipped with us.
            </RevealText>
          </h2>
        </div>

        {/* Quote grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-quote-${i}`}
              className="card-base relative rounded-2xl p-8"
            >
              <div className="text-[#B026FF] font-display text-5xl leading-none mb-4">“</div>
              <blockquote className="text-white/85 leading-relaxed text-base">
                {q.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#B026FF] to-[#6B0FBF] flex items-center justify-center font-display font-bold text-white">
                  {q.author.charAt(0)}
                </div>
                <div>
                  <div className="text-sm text-white font-medium">{q.author}</div>
                  <div className="text-xs text-white/50">{q.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Avatar marquee */}
        <div
          data-testid="avatar-marquee"
          className="relative overflow-hidden py-4"
          style={{
            maskImage:
              "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
            WebkitMaskImage:
              "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
          }}
        >
          <div className="flex gap-6 marquee-track w-max">
            {loop.map((a, i) => (
              <div
                key={`${a.name}-${i}`}
                className="flex flex-col items-center gap-2 w-24 shrink-0"
              >
                <div className="relative">
                  <div className="absolute -inset-1 rounded-full bg-[#B026FF]/30 blur-md opacity-0 hover:opacity-100 transition" />
                  <img
                    src={a.src}
                    alt={a.name}
                    className="relative w-16 h-16 rounded-full object-cover border-2 border-white/15"
                    loading="lazy"
                  />
                </div>
                <div className="text-[11px] text-white/70 text-center leading-tight">
                  {a.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
